// extracted by mini-css-extract-plugin
export var currencyInput = "_l1-1";
export var currencySymbol = "_l1-0";